import { config } from '@iheartjane/config';
import { asyncFlagProvider } from '@iheartjane/feature-flags';
import { lazy } from 'react';
import { createRoot } from 'react-dom/client';

import { bootstrap } from '@jane/monolith/bootstrap';
import { ConfigureStore } from '@jane/monolith/customer/configureStore';
import { ErrorBoundary, LegacyAppWrapper } from '@jane/shared-ecomm/components';
import { ResizeIframeProvider } from '@jane/shared-ecomm/providers';
import {
  EcommAppProvider,
  ScrollRestorationProvider,
} from '@jane/shared/providers';

import '@iheartjane/reefer/styles/index.css';

const App = lazy(() => import('./main').then((a) => ({ default: a.App })));

// eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-module-scope
const container = document.getElementById('app');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);

(async () => {
  const FlagProvider = await asyncFlagProvider({
    application: { id: 'embed', version: config.appVersion },
    baseUrl: config.launchDarklyBaseUrl,
    clientSideID: config.launchDarklyClientID,
    eventsUrl: config.launchDarklyEventsUrl,
    streamUrl: config.launchDarklyStreamUrl,
  });
  await bootstrap();
  root.render(
    <ErrorBoundary withReeferThemeProvider>
      <EcommAppProvider appMode="embedded">
        <FlagProvider>
          <LegacyAppWrapper>
            <ConfigureStore>
              <ResizeIframeProvider>
                <ScrollRestorationProvider isIframe>
                  <App />
                </ScrollRestorationProvider>
              </ResizeIframeProvider>
            </ConfigureStore>
          </LegacyAppWrapper>
        </FlagProvider>
      </EcommAppProvider>
    </ErrorBoundary>
  );
})();
